(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $838c7da815eadcf3$exports = {};
/*! yt-player. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $6e2b186194ca9ee7$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6e2b186194ca9ee7$var$R = typeof Reflect === 'object' ? Reflect : null;
var $6e2b186194ca9ee7$var$ReflectApply = $6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.apply === 'function' ? $6e2b186194ca9ee7$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $6e2b186194ca9ee7$var$ReflectOwnKeys;
if ($6e2b186194ca9ee7$var$R && typeof $6e2b186194ca9ee7$var$R.ownKeys === 'function') $6e2b186194ca9ee7$var$ReflectOwnKeys = $6e2b186194ca9ee7$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $6e2b186194ca9ee7$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $6e2b186194ca9ee7$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $6e2b186194ca9ee7$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $6e2b186194ca9ee7$var$EventEmitter() {
    $6e2b186194ca9ee7$var$EventEmitter.init.call(this);
}
$6e2b186194ca9ee7$exports = $6e2b186194ca9ee7$var$EventEmitter;
$6e2b186194ca9ee7$exports.once = $6e2b186194ca9ee7$var$once;
// Backwards-compat with node 0.10.x
$6e2b186194ca9ee7$var$EventEmitter.EventEmitter = $6e2b186194ca9ee7$var$EventEmitter;
$6e2b186194ca9ee7$var$EventEmitter.prototype._events = undefined;
$6e2b186194ca9ee7$var$EventEmitter.prototype._eventsCount = 0;
$6e2b186194ca9ee7$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $6e2b186194ca9ee7$var$defaultMaxListeners = 10;
function $6e2b186194ca9ee7$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($6e2b186194ca9ee7$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $6e2b186194ca9ee7$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $6e2b186194ca9ee7$var$defaultMaxListeners = arg;
    }
});
$6e2b186194ca9ee7$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$6e2b186194ca9ee7$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $6e2b186194ca9ee7$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $6e2b186194ca9ee7$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $6e2b186194ca9ee7$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $6e2b186194ca9ee7$var$_getMaxListeners(this);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $6e2b186194ca9ee7$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $6e2b186194ca9ee7$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$6e2b186194ca9ee7$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $6e2b186194ca9ee7$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $6e2b186194ca9ee7$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $6e2b186194ca9ee7$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, false);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.on = $6e2b186194ca9ee7$var$EventEmitter.prototype.addListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $6e2b186194ca9ee7$var$_addListener(this, type, listener, true);
};
function $6e2b186194ca9ee7$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $6e2b186194ca9ee7$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $6e2b186194ca9ee7$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.once = function once(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.on(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $6e2b186194ca9ee7$var$checkListener(listener);
    this.prependListener(type, $6e2b186194ca9ee7$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $6e2b186194ca9ee7$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $6e2b186194ca9ee7$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.off = $6e2b186194ca9ee7$var$EventEmitter.prototype.removeListener;
$6e2b186194ca9ee7$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $6e2b186194ca9ee7$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $6e2b186194ca9ee7$var$unwrapListeners(evlistener) : $6e2b186194ca9ee7$var$arrayClone(evlistener, evlistener.length);
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, true);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $6e2b186194ca9ee7$var$_listeners(this, type, false);
};
$6e2b186194ca9ee7$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $6e2b186194ca9ee7$var$listenerCount.call(emitter, type);
};
$6e2b186194ca9ee7$var$EventEmitter.prototype.listenerCount = $6e2b186194ca9ee7$var$listenerCount;
function $6e2b186194ca9ee7$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$6e2b186194ca9ee7$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $6e2b186194ca9ee7$var$ReflectOwnKeys(this._events) : [];
};
function $6e2b186194ca9ee7$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $6e2b186194ca9ee7$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $6e2b186194ca9ee7$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $6e2b186194ca9ee7$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $6e2b186194ca9ee7$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $6e2b186194ca9ee7$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}


var $838c7da815eadcf3$require$EventEmitter = $6e2b186194ca9ee7$exports.EventEmitter;
var $d98a79abea58eec1$exports = {};
/*! load-script2. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ $d98a79abea58eec1$exports = function loadScript2(src, attrs, parentNode) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement('script');
        script.async = true;
        script.src = src;
        for (const [k, v] of Object.entries(attrs || {}))script.setAttribute(k, v);
        script.onload = ()=>{
            script.onerror = script.onload = null;
            resolve(script);
        };
        script.onerror = ()=>{
            script.onerror = script.onload = null;
            reject(new Error(`Failed to load ${src}`));
        };
        const node = parentNode || document.head || document.getElementsByTagName('head')[0];
        node.appendChild(script);
    });
};


const $838c7da815eadcf3$var$YOUTUBE_IFRAME_API_SRC = 'https://www.youtube.com/iframe_api';
const $838c7da815eadcf3$var$YOUTUBE_STATES = {
    '-1': 'unstarted',
    0: 'ended',
    1: 'playing',
    2: 'paused',
    3: 'buffering',
    5: 'cued'
};
const $838c7da815eadcf3$var$YOUTUBE_ERROR = {
    // The request contains an invalid parameter value. For example, this error
    // occurs if you specify a videoId that does not have 11 characters, or if the
    // videoId contains invalid characters, such as exclamation points or asterisks.
    INVALID_PARAM: 2,
    // The requested content cannot be played in an HTML5 player or another error
    // related to the HTML5 player has occurred.
    HTML5_ERROR: 5,
    // The video requested was not found. This error occurs when a video has been
    // removed (for any reason) or has been marked as private.
    NOT_FOUND: 100,
    // The owner of the requested video does not allow it to be played in embedded
    // players.
    UNPLAYABLE_1: 101,
    // This error is the same as 101. It's just a 101 error in disguise!
    UNPLAYABLE_2: 150
};
const $838c7da815eadcf3$var$loadIframeAPICallbacks = [];
/**
 * YouTube Player. Exposes a better API, with nicer events.
 * @param {HTMLElement|selector} element
 */ class $838c7da815eadcf3$var$YouTubePlayer extends $838c7da815eadcf3$require$EventEmitter {
    constructor(element, opts){
        super();
        const elem = typeof element === 'string' ? document.querySelector(element) : element;
        if (elem.id) this._id = elem.id // use existing element id
        ;
        else this._id = elem.id = 'ytplayer-' + Math.random().toString(16).slice(2, 8);
        this._opts = Object.assign({
            width: 640,
            height: 360,
            autoplay: false,
            captions: undefined,
            controls: true,
            keyboard: true,
            fullscreen: true,
            annotations: true,
            modestBranding: false,
            related: true,
            timeupdateFrequency: 1000,
            playsInline: true,
            start: 0
        }, opts);
        this.videoId = null;
        this.destroyed = false;
        this._api = null;
        this._autoplay = false // autoplay the first video?
        ;
        this._player = null;
        this._ready = false // is player ready?
        ;
        this._queue = [];
        this._interval = null;
        // Setup listeners for 'timeupdate' events. The YouTube Player does not fire
        // 'timeupdate' events, so they are simulated using a setInterval().
        this._startInterval = this._startInterval.bind(this);
        this._stopInterval = this._stopInterval.bind(this);
        this.on('playing', this._startInterval);
        this.on('unstarted', this._stopInterval);
        this.on('ended', this._stopInterval);
        this.on('paused', this._stopInterval);
        this.on('buffering', this._stopInterval);
        this._loadIframeAPI((err, api)=>{
            if (err) return this._destroy(new Error('YouTube Iframe API failed to load'));
            this._api = api;
            // If load(videoId, [autoplay, [size]]) was called before Iframe API
            // loaded, ensure it gets called again now
            if (this.videoId) this.load(this.videoId, this._autoplay, this._start);
        });
    }
    load(videoId, autoplay = false, start = 0) {
        if (this.destroyed) return;
        this.videoId = videoId;
        this._autoplay = autoplay;
        this._start = start;
        // If the Iframe API is not ready yet, do nothing. Once the Iframe API is
        // ready, `load(this.videoId)` will be called.
        if (!this._api) return;
        // If there is no player instance, create one.
        if (!this._player) {
            this._createPlayer(videoId);
            return;
        }
        // If the player instance is not ready yet, do nothing. Once the player
        // instance is ready, `load(this.videoId)` will be called. This ensures that
        // the last call to `load()` is the one that takes effect.
        if (!this._ready) return;
        // If the player instance is ready, load the given `videoId`.
        if (autoplay) this._player.loadVideoById(videoId, start);
        else this._player.cueVideoById(videoId, start);
    }
    play() {
        if (this._ready) this._player.playVideo();
        else this._queueCommand('play');
    }
    pause() {
        if (this._ready) this._player.pauseVideo();
        else this._queueCommand('pause');
    }
    stop() {
        if (this._ready) this._player.stopVideo();
        else this._queueCommand('stop');
    }
    seek(seconds) {
        if (this._ready) this._player.seekTo(seconds, true);
        else this._queueCommand('seek', seconds);
    }
    setVolume(volume) {
        if (this._ready) this._player.setVolume(volume);
        else this._queueCommand('setVolume', volume);
    }
    getVolume() {
        return this._ready && this._player.getVolume() || 0;
    }
    mute() {
        if (this._ready) this._player.mute();
        else this._queueCommand('mute');
    }
    unMute() {
        if (this._ready) this._player.unMute();
        else this._queueCommand('unMute');
    }
    isMuted() {
        return this._ready && this._player.isMuted() || false;
    }
    setSize(width, height) {
        if (this._ready) this._player.setSize(width, height);
        else this._queueCommand('setSize', width, height);
    }
    setPlaybackRate(rate) {
        if (this._ready) this._player.setPlaybackRate(rate);
        else this._queueCommand('setPlaybackRate', rate);
    }
    setPlaybackQuality(suggestedQuality) {
        if (this._ready) this._player.setPlaybackQuality(suggestedQuality);
        else this._queueCommand('setPlaybackQuality', suggestedQuality);
    }
    getPlaybackRate() {
        return this._ready && this._player.getPlaybackRate() || 1;
    }
    getAvailablePlaybackRates() {
        return this._ready && this._player.getAvailablePlaybackRates() || [
            1
        ];
    }
    getDuration() {
        return this._ready && this._player.getDuration() || 0;
    }
    getProgress() {
        return this._ready && this._player.getVideoLoadedFraction() || 0;
    }
    getState() {
        return this._ready && $838c7da815eadcf3$var$YOUTUBE_STATES[this._player.getPlayerState()] || 'unstarted';
    }
    getCurrentTime() {
        return this._ready && this._player.getCurrentTime() || 0;
    }
    destroy() {
        this._destroy();
    }
    _destroy(err) {
        if (this.destroyed) return;
        this.destroyed = true;
        if (this._player) {
            this._player.stopVideo && this._player.stopVideo();
            this._player.destroy();
        }
        this.videoId = null;
        this._id = null;
        this._opts = null;
        this._api = null;
        this._player = null;
        this._ready = false;
        this._queue = null;
        this._stopInterval();
        this.removeListener('playing', this._startInterval);
        this.removeListener('paused', this._stopInterval);
        this.removeListener('buffering', this._stopInterval);
        this.removeListener('unstarted', this._stopInterval);
        this.removeListener('ended', this._stopInterval);
        if (err) this.emit('error', err);
    }
    _queueCommand(command, ...args) {
        if (this.destroyed) return;
        this._queue.push([
            command,
            args
        ]);
    }
    _flushQueue() {
        while(this._queue.length){
            const command = this._queue.shift();
            this[command[0]].apply(this, command[1]);
        }
    }
    _loadIframeAPI(cb) {
        // If API is loaded, there is nothing else to do
        if (window.YT && typeof window.YT.Player === 'function') return cb(null, window.YT);
        // Otherwise, queue callback until API is loaded
        $838c7da815eadcf3$var$loadIframeAPICallbacks.push(cb);
        const scripts = Array.from(document.getElementsByTagName('script'));
        const isLoading = scripts.some((script)=>script.src === $838c7da815eadcf3$var$YOUTUBE_IFRAME_API_SRC);
        // If API <script> tag is not present in the page, inject it. Ensures that
        // if user includes a hardcoded <script> tag in HTML for performance, another
        // one will not be added
        if (!isLoading) $d98a79abea58eec1$exports($838c7da815eadcf3$var$YOUTUBE_IFRAME_API_SRC).catch((err)=>{
            while($838c7da815eadcf3$var$loadIframeAPICallbacks.length){
                const loadCb = $838c7da815eadcf3$var$loadIframeAPICallbacks.shift();
                loadCb(err);
            }
        });
        const prevOnYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = ()=>{
            if (typeof prevOnYouTubeIframeAPIReady === 'function') prevOnYouTubeIframeAPIReady();
            while($838c7da815eadcf3$var$loadIframeAPICallbacks.length){
                const loadCb = $838c7da815eadcf3$var$loadIframeAPICallbacks.shift();
                loadCb(null, window.YT);
            }
        };
    }
    _createPlayer(videoId) {
        if (this.destroyed) return;
        const opts = this._opts;
        this._player = new this._api.Player(this._id, {
            width: opts.width,
            height: opts.height,
            videoId: videoId,
            // (Not part of documented API) This parameter controls the hostname that
            // videos are loaded from. Set to `'https://www.youtube-nocookie.com'`
            // for enhanced privacy.
            host: opts.host,
            playerVars: {
                // This parameter specifies whether the initial video will automatically
                // start to play when the player loads. Supported values are 0 or 1. The
                // default value is 0.
                autoplay: opts.autoplay ? 1 : 0,
                // Setting the parameter's value to 1 causes closed captions to be shown
                // by default, even if the user has turned captions off. The default
                // behavior is based on user preference.
                cc_load_policy: opts.captions != null ? opts.captions !== false ? 1 : 0 : undefined,
                // Sets the player's interface language. The parameter value is an ISO
                // 639-1 two-letter language code or a fully specified locale. For
                // example, fr and fr-ca are both valid values. Other language input
                // codes, such as IETF language tags (BCP 47) might also be handled
                // properly.
                hl: opts.captions != null && opts.captions !== false ? opts.captions : undefined,
                // This parameter specifies the default language that the player will
                // use to display captions. Set the parameter's value to an ISO 639-1
                // two-letter language code.
                cc_lang_pref: opts.captions != null && opts.captions !== false ? opts.captions : undefined,
                // This parameter indicates whether the video player controls are
                // displayed. For IFrame embeds that load a Flash player, it also defines
                // when the controls display in the player as well as when the player
                // will load. Supported values are:
                //   - controls=0 – Player controls do not display in the player. For
                //                  IFrame embeds, the Flash player loads immediately.
                //   - controls=1 – (default) Player controls display in the player. For
                //                  IFrame embeds, the controls display immediately and
                //                  the Flash player also loads immediately.
                //   - controls=2 – Player controls display in the player. For IFrame
                //                  embeds, the controls display and the Flash player
                //                  loads after the user initiates the video playback.
                controls: opts.controls ? 2 : 0,
                // Setting the parameter's value to 1 causes the player to not respond to
                // keyboard controls. The default value is 0, which means that keyboard
                // controls are enabled.
                disablekb: opts.keyboard ? 0 : 1,
                // Setting the parameter's value to 1 enables the player to be
                // controlled via IFrame or JavaScript Player API calls. The default
                // value is 0, which means that the player cannot be controlled using
                // those APIs.
                enablejsapi: 1,
                // Setting this parameter to 0 prevents the fullscreen button from
                // displaying in the player. The default value is 1, which causes the
                // fullscreen button to display.
                fs: opts.fullscreen ? 1 : 0,
                // Setting the parameter's value to 1 causes video annotations to be
                // shown by default, whereas setting to 3 causes video annotations to not
                // be shown by default. The default value is 1.
                iv_load_policy: opts.annotations ? 1 : 3,
                // This parameter lets you use a YouTube player that does not show a
                // YouTube logo. Set the parameter value to 1 to prevent the YouTube logo
                // from displaying in the control bar. Note that a small YouTube text
                // label will still display in the upper-right corner of a paused video
                // when the user's mouse pointer hovers over the player.
                modestbranding: opts.modestBranding ? 1 : 0,
                // This parameter provides an extra security measure for the IFrame API
                // and is only supported for IFrame embeds. If you are using the IFrame
                // API, which means you are setting the enablejsapi parameter value to 1,
                // you should always specify your domain as the origin parameter value.
                origin: window.location.origin,
                // This parameter controls whether videos play inline or fullscreen in an
                // HTML5 player on iOS. Valid values are:
                //   - 0: This value causes fullscreen playback. This is currently the
                //        default value, though the default is subject to change.
                //   - 1: This value causes inline playback for UIWebViews created with
                //        the allowsInlineMediaPlayback property set to TRUE.
                playsinline: opts.playsInline ? 1 : 0,
                // This parameter indicates whether the player should show related
                // videos from the same channel (0) or from any channel (1) when
                // playback of the video ends. The default value is 1.
                rel: opts.related ? 1 : 0,
                // (Not part of documented API) Allow html elements with higher z-index
                // to be shown on top of the YouTube player.
                wmode: 'opaque',
                // This parameter causes the player to begin playing the video at the given number
                // of seconds from the start of the video. The parameter value is a positive integer.
                // Note that similar to the seek function, the player will look for the closest
                // keyframe to the time you specify. This means that sometimes the play head may seek
                // to just before the requested time, usually no more than around two seconds.
                start: opts.start
            },
            events: {
                onReady: ()=>this._onReady(videoId),
                onStateChange: (data)=>this._onStateChange(data),
                onPlaybackQualityChange: (data)=>this._onPlaybackQualityChange(data),
                onPlaybackRateChange: (data)=>this._onPlaybackRateChange(data),
                onError: (data)=>this._onError(data)
            }
        });
    }
    /**
   * This event fires when the player has finished loading and is ready to begin
   * receiving API calls.
   */ _onReady(videoId) {
        if (this.destroyed) return;
        this._ready = true;
        // Once the player is ready, always call `load(videoId, [autoplay, [size]])`
        // to handle these possible cases:
        //
        //   1. `load(videoId, true)` was called before the player was ready. Ensure that
        //      the selected video starts to play.
        //
        //   2. `load(videoId, false)` was called before the player was ready. Now the
        //      player is ready and there's nothing to do.
        //
        //   3. `load(videoId, [autoplay])` was called multiple times before the player
        //      was ready. Therefore, the player was initialized with the wrong videoId,
        //      so load the latest videoId and potentially autoplay it.
        this.load(this.videoId, this._autoplay, this._start);
        this._flushQueue();
    }
    /**
   * Called when the player's state changes. We emit friendly events so the user
   * doesn't need to use YouTube's YT.PlayerState.* event constants.
   */ _onStateChange(data) {
        if (this.destroyed) return;
        const state = $838c7da815eadcf3$var$YOUTUBE_STATES[data.data];
        if (state) {
            // Send a 'timeupdate' anytime the state changes. When the video halts for any
            // reason ('paused', 'buffering', or 'ended') no further 'timeupdate' events
            // should fire until the video unhalts.
            if ([
                'paused',
                'buffering',
                'ended'
            ].includes(state)) this._onTimeupdate();
            this.emit(state);
            // When the video changes ('unstarted' or 'cued') or starts ('playing') then a
            // 'timeupdate' should follow afterwards (never before!) to reset the time.
            if ([
                'unstarted',
                'playing',
                'cued'
            ].includes(state)) this._onTimeupdate();
        } else throw new Error('Unrecognized state change: ' + data);
    }
    /**
   * This event fires whenever the video playback quality changes. Possible
   * values are: 'small', 'medium', 'large', 'hd720', 'hd1080', 'highres'.
   */ _onPlaybackQualityChange(data) {
        if (this.destroyed) return;
        this.emit('playbackQualityChange', data.data);
    }
    /**
   * This event fires whenever the video playback rate changes.
   */ _onPlaybackRateChange(data) {
        if (this.destroyed) return;
        this.emit('playbackRateChange', data.data);
    }
    /**
   * This event fires if an error occurs in the player.
   */ _onError(data) {
        if (this.destroyed) return;
        const code = Number(data.data);
        // The HTML5_ERROR error occurs when the YouTube player needs to switch from
        // HTML5 to Flash to show an ad. Ignore it.
        if (code === $838c7da815eadcf3$var$YOUTUBE_ERROR.HTML5_ERROR) return;
        // The remaining error types occur when the YouTube player cannot play the
        // given video. This is not a fatal error. Report it as unplayable so the user
        // has an opportunity to play another video.
        if (code === $838c7da815eadcf3$var$YOUTUBE_ERROR.UNPLAYABLE_1 || code === $838c7da815eadcf3$var$YOUTUBE_ERROR.UNPLAYABLE_2 || code === $838c7da815eadcf3$var$YOUTUBE_ERROR.NOT_FOUND || code === $838c7da815eadcf3$var$YOUTUBE_ERROR.INVALID_PARAM) return this.emit('unplayable', this.videoId);
        // Unexpected error, does not match any known type
        this._destroy(new Error('YouTube Player Error. Unknown error code: ' + code));
    }
    /**
   * This event fires when the time indicated by the `getCurrentTime()` method
   * has been updated.
   */ _onTimeupdate() {
        this.emit('timeupdate', this.getCurrentTime());
    }
    _startInterval() {
        this._interval = setInterval(()=>this._onTimeupdate(), this._opts.timeupdateFrequency);
    }
    _stopInterval() {
        clearInterval(this._interval);
        this._interval = null;
    }
}
$838c7da815eadcf3$exports = $838c7da815eadcf3$var$YouTubePlayer;


var $cf0ceaf2eb485d73$export$2e2bcd8739ae039 = {
    init () {
        if (!document.body.classList.contains('node--type-custom-page')) return;
        document.querySelectorAll('.block-inline-blockvideo-carousel').forEach((element)=>{
            this.finalize(element);
        });
    },
    finalize (element) {
        const videoItems = element.querySelectorAll('.video-item');
        const modal = element.querySelector('.video-modal');
        const videoHolder = modal.querySelector('.video-player');
        let modalTitle = modal.querySelector('.title');
        let ytPlayer;
        videoItems.forEach((videoItem)=>{
            videoItem.addEventListener('click', (event)=>{
                event.preventDefault();
                ytPlayer = new (0, (/*@__PURE__*/$parcel$interopDefault($838c7da815eadcf3$exports)))(videoHolder, {
                    autoplay: true,
                    controls: false,
                    keyboard: false,
                    annotations: false,
                    modestBranding: true,
                    related: false
                });
                ytPlayer.load(videoItem.dataset.videoId);
                ytPlayer.play();
                modalTitle.innerHTML = videoItem.dataset.title;
                modal.classList.add('show');
            });
        });
        const close = modal.querySelector('.modal-close');
        close.addEventListener('click', (event)=>{
            event.preventDefault();
            modalTitle.innerHTML = '';
            ytPlayer.stop();
            ytPlayer.destroy();
            modal.classList.remove('show');
        });
    }
};


'use strict';
var $678946994983f24d$export$2e2bcd8739ae039 = {
    init () {
        /*const resourceQuery = document.querySelector('#resource-query');

    if (resourceQuery) {
      resourceQuery.addEventListener('click', (event) => {
        event.preventDefault();

        const wrap = document.querySelector('.resource-search__wrapper');
        wrap.classList.toggle('open');
      });
    }*/ const resourceFilter = document.querySelector('#resource-filter');
        if (resourceFilter) resourceFilter.addEventListener('click', (event)=>{
            event.preventDefault();
            const dropdown = document.querySelector('.dropdown');
            dropdown.classList.toggle('d-none');
        });
    }
};


'use strict';
var $355a90eca8bf109b$export$2e2bcd8739ae039 = {
    init () {
        this.finalize();
    },
    finalize () {
        const btnRateCta = document.querySelector('.btn-rate-cta a');
        if (btnRateCta) btnRateCta.addEventListener('click', (e)=>{
            e.preventDefault();
            const t = document.querySelector(`.${btnRateCta.dataset.target}`);
            if (t) {
                t.classList.add('open');
                const c = t.querySelector('.close');
                c.addEventListener('click', (e)=>{
                    e.preventDefault();
                    t.classList.remove('open');
                });
            }
        });
    }
};


'use strict';
window.addEventListener('DOMContentLoaded', function() {
    (0, $cf0ceaf2eb485d73$export$2e2bcd8739ae039).init();
    (0, $678946994983f24d$export$2e2bcd8739ae039).init();
    (0, $355a90eca8bf109b$export$2e2bcd8739ae039).init();
});

})();
//# sourceMappingURL=app.js.map
